import { render } from "./PersonalitiesFile.vue?vue&type=template&id=0455c23c"
import script from "./PersonalitiesFile.vue?vue&type=script&lang=js"
export * from "./PersonalitiesFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__